import { Box, Typography } from "@mui/material";
import { AppBar as RaAppBar } from "react-admin";
import logo from "../assets/nyu-langone-health-logo.svg";

export const AppBar = (props: any) => {
	return (
		<RaAppBar color="primary" sx={{ p: 0.5 }} {...props}>
			<Typography
				variant="h6"
				color="inherit"
				id="react-admin-title"
				sx={{
					flex: 1,
					textOverflow: "ellipsis",
					whiteSpace: "nowrap",
					overflow: "hidden",
				}}
			/>
			<Box
				sx={{
					position: "absolute",
					left: "50%",
					top: "50%",
					transform: "translate(-50%, -50%)",
					display: { xs: "none", sm: "block" },
				}}
			>
				<img src={logo} alt="NYU Langone Health logo" />
			</Box>
		</RaAppBar>
	);
};
